module.exports = __webpack_public_path__ + "dist/media/logo--sv.477c7120.svg";